import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getLandingPageSettings, getLandingPageSubdomain, getLandingPageCname, getCompanyLogoUrl, getOnboardingPlaybookId } from 'modules/playbook/selectors'
import { updateCLPSettings } from 'modules/playbook/actions'

import OnboardingPlaybookCLPUrlStep from 'layouts/OnboardingPlaybookCLPUrlStep'
import { getEmbedId } from 'modules/org/selectors'

const mapStateToProps = state => ({
  logoUrl: getCompanyLogoUrl(state),
  embedId: getEmbedId(state),
  landingPageSettings: getLandingPageSettings(state),
  landingPageSubdomain: getLandingPageSubdomain(state),
  landingPageCname: getLandingPageCname(state),
  playbookId: getOnboardingPlaybookId(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateCLPSettings,
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPlaybookCLPUrlStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/CLPUrlStep/index.js